// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__EwVYi","social":"Footer_social__2oU8C"};